import { message } from "antd";
import {
  ADD_STUDENT_REQUEST,
  ADD_STUDENT_SUCCESS,
  ADD_STUDENT_FAIL,
  GET_STUDENT_REQUEST,
  GET_STUDENT_SUCCESS,
  GET_STUDENT_FAIL,
  GET_BATCH_STUDENT_REQUEST,
  GET_BATCH_STUDENT_SUCCESS,
  GET_BATCH_STUDENT_FAIL,
  UPDATE_STUDENT_REQUEST,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_FAIL,
  DELETE_STUDENT_REQUEST,
  DELETE_STUDENT_SUCCESS,
  DELETE_STUDENT_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/studentConstants";
import axios from "../../../axiosInstance";

// Add Student
export const addStudent = (studentData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_STUDENT_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.post(
      "/api/v1/student/admin-add-student",
      studentData,
      config
    );
    if (data?.success === true) {
      dispatch({ type: ADD_STUDENT_SUCCESS, payload: data });
      message.success(data?.message || "Student details added successfully");
    } else {
      throw new Error(data?.message || "Failed to student details");
    }
  } catch (error) {
    dispatch({
      type: ADD_STUDENT_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to student details"
    );
  }
};

// Get all students
export const getStudents = () => async (dispatch) => {
  try {
    dispatch({ type: GET_STUDENT_REQUEST });

    const { data } = await axios.get("/api/v1/student/admin-get-student");

    dispatch({ type: GET_STUDENT_SUCCESS, payload: data.student });
  } catch (error) {
    dispatch({
      type: GET_STUDENT_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// Get students by batch ID
export const getBatchStudents = (batchId) => async (dispatch) => {
  try {
    dispatch({ type: GET_BATCH_STUDENT_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.post(
      "/api/v1/student/admin-get-batch-id-student",
      { batchId },
      config
    );

    if (data?.success === true) {
      dispatch({ type: GET_BATCH_STUDENT_SUCCESS, payload: data.students });
      // message.success(data?.message || "Student details fetched by batch ID successfully");
    } else {
      throw new Error(data?.message || "No student found with this batch ID");
    }
  } catch (error) {
    dispatch({
      type: GET_BATCH_STUDENT_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to get batch student details"
    );
  }
};

// Update Student
export const updateStudent = (id, studentData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_STUDENT_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.put(
      "/api/v1/student/admin-update-student",
      { id, studentData },
      config
    );

    if (data?.success === true) {
      dispatch({ type: UPDATE_STUDENT_SUCCESS, payload: data.student });
      message.success(data?.message || "Student details updated successfully");
    } else {
      throw new Error(data?.message || "Failed to update student details");
    }
  } catch (error) {
    dispatch({
      type: UPDATE_STUDENT_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to update student details"
    );
  }
};

// Delete Student
export const deleteStudent = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_STUDENT_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.delete(
      "/api/v1/student/admin-delete-student",
      { data: { id } },
      config
    );

    if (data?.success === true) {
      dispatch({ type: DELETE_STUDENT_SUCCESS, payload: data.message });

      message.success(data?.message || "Student deleted successfully");
    } else {
      throw new Error(
        data?.data?.message || "Failed to delete student details"
      );
    }
  } catch (error) {
    dispatch({
      type: DELETE_STUDENT_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to delete student details"
    );
  }
};

// Clear Errors
export const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};